export const socialLinks = [
  // {
  //   id: 1,
  //   name: 'Website',
  //   icon: 'globe',
  //   url: 'https://takanorifujiki-portfolio.web.app/',
  // },
  {
    id: 2,
    name: 'GitHub',
    icon: 'github',
    url: 'https://github.com/TKNRFJK1208',
  },
  {
    id: 3,
    name: 'Twitter',
    icon: 'twitter',
    url: 'https://x.com/taka_abroad',
  },
  {
    id: 4,
    name: 'LinkedIn',
    icon: 'linkedin',
    url: 'https://www.linkedin.com/in/takanori-fujiki-a06ab727a/',
  },
];
